import "./faq.css";
const FAQComponent = () => {
  return (
      <div className="aboutUsBlock">
          <div className="aboutus-hero-banner">
              <div className="container">
                  <h1>FAQ</h1>
              </div>
          </div>
          <div className="container">
              <section className="faq-section">
                  <h2 className="section-title">For Candidates</h2>
                  <div className="faq-group">
                      <div className="faq-item">
                          <input type="radio" name="candidate" id="faq1" checked />
                          <label htmlFor="faq1" className="faq-label">
                              Who can benefit from IamInterviewed?
                              <span className="icon">⌄</span>
                          </label>
                          <div className="faq-content">
                              <p>IamInterviewed helps candidates showcase their technical abilities such as Java, .NET, SAP, Oracle, and Project Management. There's no minimum experience required — even recent graduates can benefit from it.</p>
                          </div>
                      </div>
                      <div className="faq-item">
                          <input type="radio" name="candidate" id="faq2" />
                          <label htmlFor="faq2" className="faq-label">
                              How does IamInterviewed work?
                              <span className="icon">⌄</span>
                          </label>
                          <div className="faq-content">
                              <p>We conduct technical interviews and assign a rating between 0–5 based on your skills. Your profile and rating are then shared with employers looking for your skillset.</p>
                          </div>
                      </div>
                      <div className="faq-item">
                          <input type="radio" name="candidate" id="faq3" />
                          <label htmlFor="faq3" className="faq-label">
                              Can I register for free?
                              <span className="icon">⌄</span>
                          </label>
                          <div className="faq-content">
                              <p>Yes. Registration and profile setup are free. You only pay when scheduling an interview and obtaining your professional rating.</p>
                          </div>
                      </div>
                  </div>
                  <h2 className="section-title">For Companies</h2>
                  <div className="faq-group">
                      <div className="faq-item">
                          <input type="radio" name="company" id="faq4" checked />
                          <label htmlFor="faq4" className="faq-label">
                              Why choose IamInterviewed over traditional recruiters?
                              <span className="icon">⌄</span>
                          </label>
                          <div className="faq-content">
                              <p>Our pre-screened candidate database cuts recruitment time and costs by up to 70%. You can access reliable, rated candidates instantly.</p>
                          </div>
                      </div>
                      <div className="faq-item">
                          <input type="radio" name="company" id="faq5" />
                          <label htmlFor="faq5" className="faq-label">
                              How qualified are your interviewers?
                              <span className="icon">⌄</span>
                          </label>
                          <div className="faq-content">
                              <p>Every interviewer has over 6 years of experience, corporate exposure, and certified technical expertise to ensure accurate candidate evaluation.</p>
                          </div>
                      </div>
                  </div>
              </section>
          </div>
      </div>
  );
};
export default FAQComponent;
